import {LookupConfigSpec, LookupStepType} from 'lookup-config/LookupConfigModalConstants';

export default function isLookupConfigCustomMapping(
  lookupConfig: LookupConfigSpec,
  mappingSourceFieldId: string
): boolean {
  const lastStep = lookupConfig.lookupSteps[lookupConfig.lookupSteps.length - 1];

  if (lastStep.type === LookupStepType.SCHEMA_FIELD) {
    return lastStep.schemaField !== mappingSourceFieldId;
  }

  if (lastStep.type === LookupStepType.PROCESS_TASK_DEFINITION_FIELD) {
    return lastStep.processTaskDefinitionFieldIdentifier !== mappingSourceFieldId;
  }

  return true;
}
